import { mobiClient } from '@/services/axiosConfig'
import { TopupPackageRes, TouristPackage, TouristSaveSimRes, TouristTanConfirmIsdnReq, TouristTanConfirmReq, TouristTanConfirmRes, TouristTanCreateIsdnReq, TouristTanCreateReq, TouristTanCreateRes } from './types'

export const getPackage = async (promoCode: string | undefined): Promise<TouristPackage | undefined> => {
  try {
    const res = await mobiClient.get(
      `/touristsim/fullpackageinfo${promoCode !== undefined && promoCode !== null ? `?promoCode=${promoCode}` : ''}`
    )
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}
export const getTopupPackage = async (): Promise<TopupPackageRes | undefined> => {
  try {
    const res = await mobiClient.get(
      'touristsim/topup-packages'
    )
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}
export const touristCreateTanEmail = async (
  req: TouristTanCreateReq
): Promise<TouristTanCreateRes | undefined> => {
  try {
    const res = await mobiClient.post('/touristsim/tancreate', req)
    console.log('error1', res)
    return res.data
  } catch (e: any) {
    console.error(e)
    return e.response?.data
  }
}

export const touristConfirmTanEmail = async (
  req: TouristTanConfirmReq
): Promise<TouristTanConfirmRes | undefined> => {
  try {
    const res = await mobiClient.post('/touristsim/tanconfirm', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const touristCreateTanIsdn = async (
  req: TouristTanCreateIsdnReq
): Promise<TouristTanCreateRes | undefined> => {
  try {
    const res = await mobiClient.post('/touristsim/tancreatebyisdn', req)
    return res.data
  } catch (e: any) {
    console.error(e)
    return e.response?.data
  }
}

export const touristConfirmTanIsdn = async (
  req: TouristTanConfirmIsdnReq
): Promise<TouristTanConfirmRes | undefined> => {
  try {
    const res = await mobiClient.post('/touristsim/tanconfirmbyisdn', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const touristSaveEsim = async (): Promise<TouristSaveSimRes | undefined> => {
  try {
    const res = await mobiClient.post('/touristsim/selectesim', { channel: 'mobicom_web' })
    return res.data
  } catch (e: any) {
    console.error(e)
    return e.response.data
  }
}

export const touristSaveSelfSim = async (imsi: string): Promise<TouristSaveSimRes | undefined> => {
  try {
    const res = await mobiClient.post('/touristsim/selectselfsim', { imsi })
    return res.data
  } catch (e: any) {
    console.error(e)
    return e.response.data
  }
}
